import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, Flex } from '@rebass/grid';
import get from 'lodash/get';
import { prop } from 'styled-tools';
import { ErrorMessage, Formik } from 'formik';
import * as Yup from 'yup';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { Checkbox, ListItemText, MenuItem, Select as MUISelect } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { areas, primarySchools, secondarySchools, tertiarySchools } from '../../../constants/school_list';
import Button from '../../atoms/Button';
import Image from '../../atoms/Image';
import Input from '../../atoms/Input';
import { createCompetitionUser } from '../../../api/competition';
import { withAuth } from '../../../context/auth';
import { withLoading } from '../../../context/loading';
import logoImg from '../../../assets/digital_logo.png';
import chooseTemplateImg from '../../../assets/choose-template.png';
import checkedBox from '../../../assets/checked-checkbox.png';
import uncheckedBox from '../../../assets/unchecked-checkbox.png';
import confirmButton from '../../../assets/confirm-button.png';
import arrow from '../../../assets/arrow.png';
import { dresses } from '../../../constants/dresses';
import { getCompetitionClothingTemplates } from '../../../api/info';

const SyledRadio = (props) => {
  return <Radio
    sx={{
      padding: 0,
      marginRight: '0.5rem',
      color: '#acaead',
      '&.Mui-checked': {
        color: '#ee0c7b',
      },
    }}
    {...props}
  />
}

const Select = styled('select')`
  border: 0;
  color: #6a6a6a;
  font-size: 1rem;
  width: 100%;
  background: transparent;
  -moz-appearance: none; 
  -webkit-appearance: none; 
  appearance: none;
  background: url(${prop('arrowImage')}) no-repeat 95% 50%;
  background-size: 15px auto;
`
const CustomMUISelect = styled(MUISelect)`
  border: 0;
  color: #6a6a6a;
  font-size: 1rem;
  width: 100%;
  background: transparent;
  -moz-appearance: none; 
  -webkit-appearance: none; 
  appearance: none;
  background: url(${prop('arrowImage')}) no-repeat 95% 50%;
  background-size: 15px auto;
`

const FieldContainer = styled(Flex)`
  background: white;
  height: 40px;
  margin-bottom: 0.5rem;
  padding: 0.5rem;
  border-radius: 6px;
  border: 2px solid #acaead;
  box-shadow: 2px 0px 3px #acaead, -2px 0px 3px #acaead;
  color: #6a6a6a;
  align-items: center;
`

const Container = styled(Flex)`
  background: url(${prop('background')}) no-repeat center;
  background-size: 100% 100%;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 100%;
  height: 100%;
`;

const Header = styled(Flex)`
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 2rem;
  margin-bottom: 2rem;
`

const Content = styled(Flex)`
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 80%;
  height: 100%;
`;

const Error = styled(ErrorMessage)`
  color: red;
  margin-top: -0.25rem;
  margin-bottom: 0.5rem;
`;

const PlusMinusButton = styled('button')`
  background-color: transparent;
  border: none;
  margin-left: 10;
  margin-right: 10;
  cursor: pointer;
`;

const SchoolList = (props) => {
  const { area, group } = props;
  if (group === 'primary') {
    return primarySchools[area].map((school, index) => <option value={school} key={school+index}>{school}</option>)
  } else if (group === 'secondary') {
    return secondarySchools[area].map((school, index) => <option value={school} key={school+index}>{school}</option>)
  }
  else {
    return tertiarySchools.map((school, index) => <option value={school} key={school+index}>{school}</option>)
  }
}

const DIGITAL_COMPETITION_ID = '38401590-9506-4a0b-8870-5e2d48383cb6';

class DigitalRegister extends React.Component {

  state = {
    isOther: false,
    joinedSchools: 0,
    selectedDresses: [],
    clothingTemplates: [],
    dresses: dresses,
  }

  componentDidMount() {
    this.setState({ clothingTemplates: [] });
  }
  
  _getCompetitionClothingTemplates = (group) => {
    const { auth, setAuth } = this.props;
    const params = {
      competition: '38401590-9506-4a0b-8870-5e2d48383cb6',
      'competition_user[null]': true,
      group: group,
    }
    return getCompetitionClothingTemplates(params, auth, setAuth).then(obj => {
      if (obj && obj.status === 200 && !obj.error) {
        const clothingTemplates = [];
        for (let i = 0; i < dresses.length; i++) {
          clothingTemplates[i] = dresses[i];
        }
        obj.data.forEach(clothingTemplate => {
          const clothingPresetId = clothingTemplate.clothing_preset;
          const dressIndex = clothingTemplates.findIndex(dress => dress.id === clothingPresetId);
          const dress = { ...clothingTemplates[dressIndex]};
          if (!dress.count) {
            dress.count = 1;
          } else {
            dress.count += 1;
          }
          clothingTemplates[dressIndex] = dress;
        })
        this.setState({ clothingTemplates: clothingTemplates });
      }
    })
  }

  handleSelectGroup = (data, setFieldValue) => {
    setFieldValue('school', '');
    const schoolSelection = document.getElementById('school-selection');
    schoolSelection.selectedIndex = 0;
    setFieldValue('group', data);
    setFieldValue('selectedDresses', []);
    this._getCompetitionClothingTemplates(data).then(() => {
      this.setState({ selectedDresses: [], dresses: dresses });
    })
  }

  handleSelectArea = (data, setFieldValue) => {
    setFieldValue('school', '');
    const schoolSelection = document.getElementById('school-selection');
    schoolSelection.selectedIndex = 0;
    setFieldValue('area', data);
  }

  handleSelectSchool = (data, setFieldValue) => {
    if (data === 'other') {
      setFieldValue('school', '');
      this.setState({ isOther: true });
    } else {
      setFieldValue('school', data);
      this.setState({ isOther: false });
    }
  }

  handleSelectDress = (event, setFieldValue, group) => {
    const {
      target: { value },
    } = event;
    let updateSelectedDresses = false;
    if (group === 'tertiary') {
      if (value.length <= 1) {
        updateSelectedDresses = true;
      }
    } else {
      if (value.length <= 5) {
        updateSelectedDresses = true;
      }
    }

    if (updateSelectedDresses) {
      const newSelectedDresses = typeof value === 'string' ? value.split(',') : value;
      this.setState({ selectedDresses: newSelectedDresses });
      setFieldValue('selectedDresses', newSelectedDresses);
    }
  }

  handleCreateUser = (values) => {
    const { auth, setAuth } = this.props;
    const selectedDressIds = values.selectedDresses.map(selectedDress => {
      return dresses.find(dress => dress.name === selectedDress).id
    })
    const body = {
      username: values.email,
      name: values.name,
      phone: values.phone,
      email: values.email,
      group: values.group,
      area: values.area,
      school: values.school,
      selected_dresses: selectedDressIds.join(),
      competition: DIGITAL_COMPETITION_ID,
    }
    return createCompetitionUser(body, auth, setAuth)
      .then(() => {
        alert('成功登記');
        window.location.reload();
      })
      .catch(err => {
        const errorResponse = get(err, 'response');
        const errorMessage = get(errorResponse, ['data', 'error'], '');
        if (errorMessage) {
          alert(errorMessage);
        }
      })
  }

  validateSchoolList = (group) => {
    const schoolSelection = document.getElementById('school-selection');
    const optionLength = schoolSelection.options.length;
    if (optionLength < 2 && group !== 'tertiary') {
      alert('請先輸入學校類別和地區');
    }
  }

  handleClickLink = (event, link) => {
    event.stopPropagation();
    window.open(link);
  }

  handlePlusMinusButtonClick = (sign, dresses, dressName, count, setFieldValue) => {
    let totalCount = 0;
    let targetDress;
    let targetIndex;
    const { selectedDresses } = this.state;
    let newDresses = [];
    for (let i = 0; i < dresses.length; i++) {
      newDresses[i] = dresses[i];
    }

    newDresses.forEach((dress, index) => {
      if (dress.count) {
        totalCount += dress.count;
      }
      if (dress.name === dressName) {
        targetIndex = index;
        targetDress = { ...newDresses[index] };
      }
    })
    if (!count) {
      count = 0;
    }
    if (sign === '+') {
      if (totalCount < 30) {        
        targetDress.count = count + 1;
        selectedDresses.push(dressName);
      } else if (totalCount >= 30) {
        alert('所選服裝設計已有30套');
      }
    } else if (sign === '-' && targetDress.count > 0) {
      targetDress.count = count - 1;
      const index = selectedDresses.indexOf(dressName);
      if (index > -1) {
        selectedDresses.splice(index, 1);
      }
    }
    newDresses[targetIndex] = targetDress;
    this.setState({ dresses: newDresses, selectedDresses: selectedDresses });
    setFieldValue('selectedDresses', selectedDresses);
  }
  
  render() {
    const { isOther, clothingTemplates, dresses } = this.state;
    const initialValues = {
      name: '',
      phone: '',
      email: '',
      group: '',
      area: '',
      school: '',
      selectedDresses: [],
      agreeTerms: false
    }
    const SignupSchema = Yup.object().shape({
      name: Yup.string().required('請輸入姓名'),
      phone: Yup.string().matches(/^[1-9][0-9]{7}/, '請輸入正確的手機號碼').required('請輸入手機號碼'),
      email: Yup.string().email('請輸入正確的電子郵箱').required('請輸入電子郵箱'),
      group: Yup.string().required('請輸入學校類別'),
      area: Yup.string()
        .test("group", "請輸入地區", function () {
          if (!this.parent.group) {
            return false;
          } 
          return true;
      }),
      school: Yup.string().required('請輸入學校名稱'),
      agreeTerms: Yup.boolean().oneOf([true], '提交申請前需同意本活動隱私聲明及條款'),
      selectedDresses: Yup.array().min(1, '請選擇至少一個民族'),
    });

    return (
      <Container>
        <Header>
          <Image id="logo" src={logoImg} width="80%" />
        </Header>
        <Content flex={1}>
          <Image src={chooseTemplateImg} width="80%" style={{ marginBottom: '1rem' }} />
          <Formik
            initialValues={{...initialValues}}
            validationSchema={SignupSchema}
            enableReinitialize
            onSubmit={(values, actions) => {
              this.handleCreateUser(values);
            }}>
            {props => (
              <form id="registrationForm" onSubmit={props.handleSubmit} style={{ width: '100%' }} >
                <Flex flexDirection="column">
                  <Flex flex={1}>
                    <RadioGroup id="radioGroup" defaultValue="" name="radio-buttons-group" style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between'}}>
                      <FieldContainer flex={1}>
                        <SyledRadio
                          value="primary"
                          onChange={() => {
                            this.handleSelectGroup('primary', props.setFieldValue);
                            props.setFieldTouched('group', false, false);
                          }}
                        />
                        小學
                      </FieldContainer>
                      <FieldContainer flex={1}>
                        <SyledRadio
                          value="secondary"
                          onChange={() => {
                            this.handleSelectGroup('secondary', props.setFieldValue);
                            props.setFieldTouched('group', false, false);
                          }}
                        />
                        中學
                      </FieldContainer>
                      <FieldContainer flex={1.5}>
                        <SyledRadio
                          value="tertiary"
                          onChange={() => {
                            this.handleSelectGroup('tertiary', props.setFieldValue);
                            props.setFieldTouched('group', false, false);
                          }}
                        />
                        大專院校
                      </FieldContainer>
                    </RadioGroup>
                  </Flex>
                  <Error component="div" name="group" />
                </Flex>
                <Flex flexDirection="column">
                  <Flex justifyContent="space-between">
                    {props.values.group !== 'tertiary' && <FieldContainer flex={2}>
                      <Select
                        arrowImage={arrow}
                        defaultValue="地區"
                        onChange={(e) => {
                          this.handleSelectArea(e.target.value, props.setFieldValue);
                          props.setFieldTouched('area', false, false);
                        }}
                      >
                          <option defaultValue="地區" disabled>地區</option>
                          {areas.map(area => <option value={area} key={area}>{area}</option>)}
                      </Select>
                    </FieldContainer>}
                    <FieldContainer flex={3}>
                      <Select
                        id="school-selection"
                        arrowImage={arrow}
                        defaultValue="院校名稱"
                        onClick={() => this.validateSchoolList(props.values.group)}
                        onChange={(e) => {
                          this.handleSelectSchool(e.target.value, props.setFieldValue);
                        }}
                      >
                        <option id="default" defaultValue="院校名稱" disabled>院校名稱</option>
                        {(props.values.area || props.values.group === 'tertiary') && props.values.group &&
                          <>
                            <SchoolList area={props.values.area} group={props.values.group} />
                            <option value="other">其他-------</option>
                          </>
                        }
                      </Select>
                    </FieldContainer>
                  </Flex>
                  <Error component="div" name="area" />
                  {!isOther && <Error component="div" name="school" />}
                </Flex>
                {isOther && <Flex flexDirection="column" color="#6a6a6a" style={{ fontWeight: 'bold'}}>
                  <Flex>
                    其他（不在上列名單的學校）
                  </Flex>
                  <Flex mt="1rem" mb="1rem">
                    <input
                      style={{ backgroundColor: 'transparent', border: 0, borderBottom: 1, borderStyle: 'solid', width: '90%', fontSize: '1rem' }}
                      placeholder="請輸入學校名稱"
                      type="text"
                      onChange={props.handleChange}
                      onBlur={props.handleBlur}
                      value={props.values.school}
                      name="school"
                    />
                  </Flex>
                  {isOther && <Error component="div" name="school" style={{ fontWeight: 'normal', marginTop: '0.5rem', marginBottom: '0.5rem'}} />}
                </Flex>}
                <Flex flexDirection="column">
                  <Flex mb="0.5rem" color="#6a6a6a" fontSize="1rem" style={{ fontWeight: 'bold' }}>
                    {`請選擇${props.values.group ? (props.values.group === 'tertiary' ? '一套' : '30套') : '' }`}
                  </Flex>
                  <Flex>
                    <FieldContainer flex={1}>
                      <CustomMUISelect
                        id="dresses-selection"
                        arrowImage={arrow}
                        value={props.values.selectedDresses}
                        fullWidth
                        multiple
                        displayEmpty
                        onBlur={props.handleBlur}
                        inputProps={{ IconComponent: () => null }}
                        sx={{
                          boxShadow: "none",
                          color: "#6a6a6a",
                          ".MuiSelect-select": { padding: 0 },
                          ".MuiOutlinedInput-notchedOutline": { border: 0 },
                          "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": { border: 0 },
                          "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": { border: 0 },
                        }}
                        renderValue={(selected) => {
                          if (selected.length === 0) {
                            return <Flex color="#6a6a6a" fontSize="1rem">請選擇民族進行該民族的服裝設計</Flex>;
                          }
                          return selected.join(', ');
                        }}
                        onChange={(e) => props.values.group === 'tertiary' && this.handleSelectDress(e, props.setFieldValue, props.values.group)}
                      >
                        <MenuItem disabled value="">
                          請選擇民族進行該民族的服裝設計
                        </MenuItem>
                        {dresses.map(dress => <MenuItem key={dress.name} value={dress.name} style={{ cursor: props.values.group === 'tertiary' ? 'pointer' : 'auto' }}>
                          {props.values.group === 'tertiary' && <Checkbox checked={props.values.selectedDresses.indexOf(dress.name) > -1}/>}
                          <ListItemText primary={dress.name} />
                          {props.values.group !== 'tertiary' && <Flex style={{position: 'absolute', left: '35%' }}>
                            <PlusMinusButton onClick={()=>this.handlePlusMinusButtonClick('+', dresses, dress.name, dress.count, props.setFieldValue)}>+</PlusMinusButton>
                            <Flex>{dress.count ? dress.count : 0}</Flex>
                            <PlusMinusButton onClick={()=>this.handlePlusMinusButtonClick('-', dresses, dress.name, dress.count, props.setFieldValue)}>-</PlusMinusButton>
                          </Flex>}
                          <Flex fontSize="0.8rem" mr={10}>{clothingTemplates.find(clothingTemplate => clothingTemplate.name === dress.name)?.count}</Flex>
                          <Flex alignItems="center" style={{ cursor: 'pointer' }} onClick={(e) => this.handleClickLink(e, dress.link)}>
                            <Flex fontSize="0.8rem" color="#6a6a6a">詳細資料</Flex>
                            <OpenInNewIcon fontSize="1rem" sx={{ color: '#6a6a6a' }} />
                          </Flex>
                        </MenuItem>)}
                      </CustomMUISelect>
                    </FieldContainer>
                  </Flex>
                  <Error component="div" name="selectedDresses" />
                </Flex>
                <Flex flexDirection="column" mt="0.5rem">
                  <FieldContainer>
                    <Input
                      type="name"
                      onChange={props.handleChange}
                      onBlur={props.handleBlur}
                      value={props.values.name}
                      placeholder={props.values.group ? props.values.group !== 'tertiary' ? '老師姓名' : '姓名' : '姓名'}
                      name="name"
                      style={{ fontSize: '1rem' }}
                    />
                  </FieldContainer>
                  <Error component="div" name="name" />
                </Flex>
                <Flex flexDirection="column">
                  <FieldContainer>
                    <Input
                      type="tel"
                      onChange={props.handleChange}
                      onBlur={props.handleBlur}
                      value={props.values.phone}
                      placeholder="手機號碼"
                      name="phone"
                      style={{ fontSize: '1rem' }}
                    />
                  </FieldContainer>
                  <Error component="div" name="phone" />
                </Flex>
                <Flex flexDirection="column">
                  <FieldContainer>
                    <Input
                      type="email"
                      onChange={props.handleChange}
                      onBlur={props.handleBlur}
                      value={props.values.email}
                      placeholder="電子郵箱"
                      name="email"
                      style={{ fontSize: '1rem' }}
                    />
                  </FieldContainer>
                  <Error component="div" name="email" />
                </Flex>
                <Flex flexDirection="column" marginY="1rem">
                  <Flex flex={1}>
                    <Flex mr="1rem" onClick={()=>{props.setFieldValue('agreeTerms', !props.values.agreeTerms)}} style={{ cursor: 'pointer' }}>
                      <Image src={props.values.agreeTerms ? checkedBox : uncheckedBox} height={20} width={20} />
                    </Flex>
                    <Flex flexDirection="column" color="#6a6a6a">
                      <Flex fontSize="1rem" style={{ fontWeight: 'bold'}}>
                        同意接受電子郵件（圖紙會郵件發送給參賽者）  
                      </Flex>
                      <Flex fontSize="0.8rem">
                        點擊登記代表你同意本活動的隱私聲明及條款並同意接受電子郵件
                      </Flex>
                    </Flex>
                  </Flex>
                  <Error component="div" name="agreeTerms" style={{ marginTop: '0.5rem', marginBottom: '-0.5rem' }} />
                </Flex>
                <Flex mb={10} flexDirection="column" fontSize="1rem" color="#6a6a6a" textAlign="justify" padding={10} style={{ border: '1px solid #6a6a6a' }}>
                  <Flex>
                    請小學和中學學校負責的老師注意，最多只有五位學生使用/體驗是次比賽之圖紙，換言之老師並不能將圖紙印出分發給全班/全級試用，再從中挑選五位學生參加比賽，如有其他問題或想全班/全級使用，請WhatsApp 65941276
                  </Flex>
                  <Flex my={10}>
                    Attention to primary and secondary school teachers: Please note that only a maximum of five students can use/experience the competition drawings. In other words, teachers cannot print and distribute the drawings to the entire class/school for trial purposes and then select five students to participate in the competition. If you have any other questions or if you would like the entire class/school to use the drawings, please WhatsApp 65941276.
                  </Flex>
                </Flex>
                <Button type="submit" style={{ padding: 0 }}>
                  <Image src={confirmButton} width="100%" />
                </Button>
              </form>
            )}
          </Formik>
          {/* {joinedSchools > 0 && <Counter>
              {joinedSchools}
          </Counter>} */}
        </Content>
      </Container>
    );
  }
}

DigitalRegister.propTypes = {
  auth: PropTypes.object,
  setAuth: PropTypes.func,
};

DigitalRegister.defaultProps = {
  auth: null,
  setAuth: () => {},
};

export default withAuth(withLoading(DigitalRegister));
